<app-root-document-viewer
  [documentUrl]="documentUrl"
  [isMissingFile]="hasNoDocument"
  missingFileTitle="Aucun document"
  (onValidate)="validate()"
  (onCancel)="close()"
  [isValidateDisabled]="!canValidate()">
  <div class="flex-vertical left-panel-content" left-panel>
    <div class="flex-vertical padding-24 gap-16">
      <h5>Ajouter depuis mes documents investisseur</h5>
      @if (investisseurs.length > 1) {
        <oui-select
          label="Investisseur"
          [control]="investisseurControl"
          [options]="investisseurListOptions"
        class="width-100pc"></oui-select>
      }

      <!-- FIXME : waiting futur dev to be able to filter on etatSignature (currently not reliable data) -->
      <!-- <oui-select
      label="Statut signature"
      [control]="statutSignatureControl"
      [options]="statutSignatureListOptions"
    class="width-100pc"></oui-select> -->

    <oui-searchbar
      class="demo-component"
      [control]="searchControl"
      type="filter"
      placeholder="Rechercher un document">
    </oui-searchbar>
    <oui-select
      label="Catégorie"
      [control]="categoryControl"
      [options]="categoryOptions"
      class="width-100pc">
    </oui-select>
    @if (categoriesLoadFailed) {
      <p role="status">Les catégories sont indisponibles. Vous pouvez rechercher parmi tous les documents.</p>
    }
  </div>
  <div class="files-list">
    @if (isLoadingFiles) {
      <div class="etat-vide-container">
        <oui-loading></oui-loading>
      </div>
    } @else {
      @for (fileInfo of filteredFileInfoList; track fileInfo) {
        <app-file-item
          [fileName]="fileInfo?.metadata?.fileName ?? undefined"
          [withCheckBox]="isMultiple"
          [fileId]="$safeNavigationMigration(fileInfo?.metadata?.fileId)"
          [label]="generateFileLabel(fileInfo)"
          [selected]="selectedFileInfo?.metadata?.fileId === fileInfo?.metadata?.fileId"
        (click)="selectFile(fileInfo)"></app-file-item>
      } @empty {
        <div class="etat-vide-container">
          <oui-etat-vide icon="unknown_document" [title]="'Aucun document'"></oui-etat-vide>
        </div>
      }
    }
  </div>
</div>

<ng-container right-panel>
  <lib-document-viewer-header
    [documentName]="generateFileLabel(selectedFileInfo)"
    [fileName]="selectedFileInfo?.metadata?.fileName ?? undefined"
    [dateAjout]="$safeNavigationMigration(selectedFileInfo?.metadata?.dateDeDerniereModification)"
    (close)="close()">
  </lib-document-viewer-header>

  <!-- FIXME : should user be able to change type of document in ariane. For now, it's not possible but leave code available if required
  <oui-autocomplete
    label="Type de document"
    [control]="boxDocumentTypeControl"
    [options]="boxDocumentTypeListOptions"
  class="width-100pc"></oui-autocomplete>
  <oui-textfield
    label="Nom du document"
    [control]="denominationControl"
  *ngIf="denominationSelectable"></oui-textfield> -->

  @if (!hideComment) {
    <oui-textarea label="Commentaire (facultatif)" [control]="commentControl"></oui-textarea>
  }
  @if (showAllOperationsOption) {
    <oui-checkbox
      label="Ajouter dans toutes les opérations"
    [(checked)]="forAllOperations"></oui-checkbox>
  }
</ng-container>
</app-root-document-viewer>
